export const OUTPUT_TYPE = Object.freeze({ BY_JURISDICTION: 'byJurisdiction' })
